import axios from "axios";
import { toastr } from "react-redux-toastr";

import { openModal } from "./modalAction";

import {
  FETCH_REVIEW,
  FETCH_REVIEWS,
  SEARCH_REVIEWS,
  FETCHING_REVIEWS,
} from "./types";

//search  Reviews

export const searchReviews = (values,limit, offset) => async (dispatch) => {
  try {
    
    const res = await axios.post("/api/ReviewSearch", {
      values,
      limit,
      offset,
    });

    dispatch({ type: SEARCH_REVIEWS, payload: res.data });
    dispatch({ type: FETCHING_REVIEWS, payload: false });
    // dispatch(closeModal());
  } catch (error) {
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      console.log("error_review", error);
      toastr.error(
        "Oops",
        "Something went wrong.Please Try Again_searchReviews"
      );
    }
  }
};

export const fetchReviews = (values,limit, offset) => async (dispatch) => {
  try {
    
    const res = await axios.post("/api/ReviewSearch", {
      values,
      limit,
      offset,
    });

    dispatch({ type: FETCH_REVIEWS, payload: res.data });
    dispatch({ type: FETCHING_REVIEWS, payload: false });
    // dispatch(closeModal());
  } catch (error) {
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      console.log("error_review", error);
      toastr.error(
        "Oops",
        "Something went wrong.Please Try Again_fetchReviews"
      );
    }
  }
};

//fetch single Review
export const fetchReview = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/ReviewDetail/${id}`);

    dispatch({ type: FETCH_REVIEW, payload: res.data });
  } catch (error) {
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      console.log("error_fetchReview", error);
      toastr.error("Oops", "Something went wrong.Please Try Again_fetchReview");
    }
  }
};

// create Review
export const createReview = (values) => async (dispatch) => {
  try {
    const res = await axios.post("/api/ReviewCreate", {
      values,
    });

    if (res.data.msg === "success") {
      toastr.success("Review Created");
    }
  } catch (error) {
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      toastr.error(
        "Oops",
        "Something went wrong.Please Try Again_createReview"
      );
    }
  }
};

//reset Review
export const resetReview = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_REVIEW, payload: null });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again_resetReview");
  }
};
